module.exports = __webpack_public_path__ + "28bbcf7c9e948b771941de198f5ee426.png";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/images/pages/example-page-2.png
// module id = 112
// module chunks = 0